import controller from './oo-admin.controller';
import template from './oo-admin.html';

export default {
	template,
	bindings:     {
		node:      '=ngModel',
		form:      '=',
		tab:       '=?',
		options:   '<?',
		onCancel:  '&?',
		onCreated: '&?',
		onUpdated: '&?',
		onDeleted: '&?',
	},
	controller,
	controllerAs: '$ctrl',
	require:      {
		ngModelCtrl: '?ngModel',
	},
};
